import { todayISO } from "@financialharmony/tax-se";
import type { LineItem, ReceivableDraft } from "./types";

/** Shared id generator for locally-created lines/drafts — never a real DB id until saved. */
export const newId = (p: string): string => `${p}_${crypto.randomUUID()}`;

export const emptyLine = (): LineItem => ({
  id: newId("l"), description: "", quantity: 1, unit: "st", unitPrice: 0, vatRate: 25,
});

/**
 * A brand-new, empty draft. `interestRatePercent` starts `null` and is prefilled from the
 * seller once that async data resolves — the default is a server-resolved value, not
 * something this function can know up front.
 */
export const freshDraft = (): ReceivableDraft => ({
  id: newId("inv"), number: null, status: "draft", customerId: null,
  invoiceDate: todayISO(), paymentTermsDays: 30, lines: [emptyLine()],
  ourReference: "", theirReference: "", recurrence: "none", createdVia: "form",
  interestRatePercent: null, freeText: "", paymentMethod: null, receivingBankAccountId: null,
  // DB column defaults (receivables.document_language/currency) — resolveDocumentDefaults()
  // re-derives documentLanguage from the customer's country once one is picked (FIN-1580).
  documentLanguage: "sv", currency: "SEK",
});
